import React from 'react';
import Shimmer from './Shimmer';

const AssociationsShimmer = () => (
    <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* En-tête de section */}
            <div className="text-center mb-16">
                <Shimmer className="h-10 w-2/3 max-w-xl mx-auto rounded mb-4"/>
                <Shimmer className="h-6 w-full max-w-2xl mx-auto rounded"/>
            </div>

            {/* Catégories d'associations */}
            <div className="space-y-24">
                {/* Répéter pour chaque catégorie */}
                {[1, 2, 3, 4].map((categoryIndex) => (
                    <div key={categoryIndex}>
                        {/* En-tête de catégorie */}
                        <div className="flex items-center gap-4 mb-12">
                            <Shimmer className="w-16 h-16 rounded-full"/>
                            <Shimmer className="h-8 w-64 rounded"/>
                        </div>

                        {/* Grille d'associations */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
                            {/* Répéter pour chaque association */}
                            {[1, 2].map((assocIndex) => (
                                <div key={assocIndex} className="group space-y-6">
                                    {/* Image */}
                                    <div className="aspect-w-16 aspect-h-9 overflow-hidden">
                                        <Shimmer className="w-full h-full rounded"/>
                                    </div>

                                    {/* Contenu */}
                                    <div>
                                        {/* Titre et description */}
                                        <Shimmer className="h-8 w-3/4 rounded mb-3"/>
                                        <Shimmer className="h-4 w-full rounded mb-4"/>

                                        {/* Activités */}
                                        <div className="space-y-4">
                                            <div>
                                                <Shimmer className="h-6 w-48 rounded mb-2"/>
                                                {/* Liste d'activités */}
                                                {[1, 2, 3].map((activityIndex) => (
                                                    <Shimmer
                                                        key={activityIndex}
                                                        className="h-4 w-full rounded mb-2"
                                                    />
                                                ))}
                                            </div>

                                            {/* Infos membres et contact */}
                                            <div className="flex items-center justify-between mt-4">
                                                <Shimmer className="h-5 w-32 rounded"/>
                                                <Shimmer className="h-5 w-32 rounded"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* Section création d'association */}
            <div className="mt-24">
                <div className="bg-slate-100 py-16 px-8">
                    <div className="max-w-3xl mx-auto text-center">
                        <Shimmer className="w-12 h-12 rounded-full mx-auto mb-6"/>
                        <Shimmer className="h-8 w-96 mx-auto rounded mb-4"/>
                        <Shimmer className="h-6 w-full max-w-xl mx-auto rounded mb-8"/>
                        <Shimmer className="h-12 w-48 mx-auto rounded"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default AssociationsShimmer;